import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import IntegrationsDashboard from "./routes/IntegrationsDashboard";
import IntegrationsCatalog from "./routes/IntegrationsCatalog";
import IntegrationsCore from "./routes/IntegrationsCore";

export default store => ({
  path: "integrations",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "./components"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "./modules/IntegrationsModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "SyncV2/modules/SyncModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "AttendanceSync/modules/AttendanceSyncModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "TimetableSync/routes/TimetableSyncSetup/modules/TimetableSyncSetupModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "GradebookSync/modules/GradebookSyncModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
          importedModule5,
        ]) => {
          const component = importedModule0.default;
          const module = importedModule1;
          const reducer = module.default;
          const key = module.NAME;

          const rosterSyncReducer = importedModule2;

          const attendanceSyncReducer = importedModule3;

          const timetableSyncReducer = importedModule4;

          const gradebookSyncReducer = importedModule5;

          injectReducer(store, {
            key,
            reducer,
          });

          injectReducer(store, {
            key: rosterSyncReducer.NAME,
            reducer: rosterSyncReducer.default,
          });

          injectReducer(store, {
            key: attendanceSyncReducer.NAME,
            reducer: attendanceSyncReducer.default,
          });

          injectReducer(store, {
            key: timetableSyncReducer.NAME,
            reducer: timetableSyncReducer.default,
          });

          injectReducer(store, {
            key: gradebookSyncReducer.NAME,
            reducer: gradebookSyncReducer.default,
          });

          return component;
        }
      )
    // .catch(err => {
    //   console.log(err);
    //   throw err;
    // })
  ),
  childRoutes: [
    IntegrationsDashboard(store),
    IntegrationsCatalog(store),
    IntegrationsCore(store), //order maters here this has to be last as this is dynamic
  ],
});
